import { HpDispatchFunction } from './actionTypes';

export function clearPaymentErrorAction() {
  return (dispatch: HpDispatchFunction<void>): void => {
    dispatch({
      type: 'CLEAR_PAYMENT_ERROR'
    });
  };
}
